<template>
    <BaseButton
        type="button"
        theme="tertiary"
        size="sm"
        icon-only
        class="shrink-0"
        :aria-expanded="expanded"
        aria-haspopup="dialog"
        :aria-label="expanded ? t('reflections.tabInfo.hideInfo', { topic }) : t('reflections.tabInfo.showInfo', { topic })"
        @click="onToggle">
        <i class="bi bi-info-circle text-xs" aria-hidden="true"></i>
    </BaseButton>
</template>

<script setup lang="ts">
import BaseButton from "~vue/components/BaseButton.vue";
import { useI18n } from "vue-i18n";

interface Props {
    expanded: boolean;
    topic: string;
}

defineProps<Props>();
const { t } = useI18n();
const emit = defineEmits<{ (event: "toggle"): void }>();

function onToggle() {
    emit("toggle");
}
</script>
